import * as React from "react";
import { Link } from 'gatsby';
import { Container, Row, Col } from 'react-bootstrap';
import { StaticImage } from "gatsby-plugin-image";

const Events = (props) => {

  const title = props.title;
  const description = props.description;

  const EventMainImage = '../../content/blog/digipay-guru-highlights-seamless-africa-2023/digipay-guru-at-seamless-north-africa-2023-feature-digipay-guru.webp';

  return (
    <>
      <section className="section bg-light">
        <Container className="py-5 events-list">
          <div className="w-75">
            <div className="section-title mb-5 pb-1">
              <h2 className="heading fw-semibold mb-4">{title}</h2>
              <p className="lead">{description}</p>
            </div>
          </div>
          <Row className="g-5 align-items-center">
            <Col lg={7} xxl={6}>
              <div className="events-image">
                <StaticImage loading="lazy" src={EventMainImage} width={832} height={500} alt="Events Image" />
              </div>
            </Col>
            <Col lg={5} xxl={6}>
              <div className="events-list mt-5 mt-lg-0">
                <div className="events-content active">
                  <span className="mb-2 d-block">South Africa | September 19th - 20th, 2023</span>
                  <Link to="/blog/digipay-guru-highlights-seamless-africa-2023" className="h4 fw-normal font-size-22">Seamless South Africa 2023</Link>
                </div>
                <div className="events-content">
                  <span className="mb-2 d-block">North Africa | July 17th - 18th, 2023</span>
                  <Link to="/blog/digipay-guru-at-seamless-north-africa-2023" className="h4 fw-normal font-size-22">Seamless North Africa 2023</Link>
                </div>
                <div className="events-content">
                  <span className="mb-2 d-block">London | June 19th - 23rd, 2023</span>
                  <Link to="/blog/digipay-guru-at-fintech-week-london-2023" className="h4 fw-normal font-size-22">Fintech Week London 2023</Link>
                </div>
                {/* <div className="events-content">
                  <span className="mb-2 d-block">Nairobi | May 24th - 25th, 2023</span>
                  <Link to="/blog/digipay-guru-at-wfis-kenya-2023" className="h4 fw-normal font-size-22">World Financial Innovations Series 2023</Link>
                </div> */}
                {/* <div className="events-content">
                  <span className="mb-2 d-block">Nairobi | October 4th - 5th, 2022</span>
                  <Link to="/blog/digipay-guru-at-seamless-africa-2022" className="h4 fw-normal font-size-22">Seamless Africa 2022</Link>
                </div> */}
                {/* <div className="events-content">
                  <span className="mb-2 d-block">New Delhi | July 20 - July 22, 2022</span>
                  <p className="h4 fw-normal font-size-22">Fintech Festival India</p>
                </div> */}
                {/* <div className="events-content">
                  <span className="mb-2 d-block">Middle East | May 31 - June 1, 2022</span>
                  <Link to="/blog/seamless-middle-east-2022" className="h4 fw-normal font-size-22">Seamless Middle East 2022</Link>
                </div> */}
                {/* <div className="events-content">
                  <span className="mb-2 d-block">USA | 19-23 Apr 2021</span>
                  <p className="h4 fw-normal font-size-22">Money 20/20</p>
                </div> */}
              </div>
              <div className="mt-3 mt-md-5 ms-4">
                <Link to="/events" className="btn btn-link">
                  <span>view more events</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

    </>
  )
}

Events.defaultProps = {
  title: "Purposeful presence of DigiPay.Guru at enlightening FinTech Events",
  description: "DigiPay.Guru was the frontier in 2021 as a FinTech expert and exchanged dialogues on digital payment existence and future. We are excited to participate in more upcoming events to assess the latest innovations that will underpin the next phase of transformation into the finance industry.",
}

export default Events;
